import CopyContentToRfq from '../../../../../../client/src/rfq/src/viewmodel/CopyContentToRfqViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesCopyContentToRfq extends DesBaseCollabAcc {

    constructor() {
        console.log('DesCopyContentToRfq invoked');
        super(CopyContentToRfq);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get projectid() {
        return this.getAttribute('projectid') || this.getAttribute('project-id');
    }

    get contentid() {
        return this.getAttribute('contentid') || this.getAttribute('content-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            projectid: this.projectid,
            contentid: this.contentid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id', 'projectid', 'project-id', 'contentid', 'content-id'];
    }
}
if (!window.customElements.get('des-copy-content-to-rfq')) {
    window.customElements.define('des-copy-content-to-rfq', DesCopyContentToRfq);
}
